// JS for actions post bottom section

const actionsPost = document.querySelector('.js-actions-post');
const actionShare = document.querySelector('.js-action-share');
const closeShare = document.querySelector('.js-share-list .js-close');
const copyLink = document.querySelector('.js-copy-link');
const confirmCopy = document.querySelector('.js-copy-confirm');

// If there is actions
if (actionsPost !== null) {
    // Add class to container actions_post at share button click to see every share buttons
    actionShare.addEventListener('click', function () {
        actionsPost.classList.add('shared-on');
    })
    // Remove class at close button click
    closeShare.addEventListener('click', function () {
        actionsPost.classList.remove('shared-on');
        confirmCopy.classList.remove('show-hide');
    })

    // Function to copy URL
    function copy() {
        confirmCopy.classList.remove('show-hide');

        // Get the text field
        let copyText = document.querySelector("#post_url");
        copyText.focus();

        // Select the text field
        copyText.select();
        copyText.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText.value);

        confirmCopy.classList.add('show-hide');
    }

    copyLink.addEventListener("click", copy);
}


// sources : https://www.w3schools.com/howto/howto_js_copy_clipboard.asp